
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Les meilleures agences création de sites web en France - Top 2026",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez le classement 2026 des 15 meilleures agences de création de sites web en France en 2026. Trouvez le partenaire idéal pour un site moderne et performant.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Les meilleures agences création de sites web en France - Top 2026",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez le classement 2026 des 15 meilleures agences de création de sites web en France en 2026. Trouvez le partenaire idéal pour un site moderne et performant.",
        },
      ],
    };
  },
};
